import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

function Dashboard({ userEmail }) {
    const [tests, setTests] = useState([]);
    const [message, setMessage] = useState('Loading...');
  //  const [email, setEmail] = useState(null);
  //  const [token, setToken] = useState(null);
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTests = async () => {
            const token = localStorage.getItem('jwtToken');
            //loading guard in case context loading is too slow
            if (!token || user === null) {
                return <p>Checking session...</p>; // avoid redirect during context load
            }

            const email = user?.email || localStorage.getItem('email'); // fallback
            if (!token || !email) {
                navigate('/');
                return;
            }

            try {
                const response = await fetch('https://vvti852naj.execute-api.us-east-1.amazonaws.com/Prod/GetUserTests', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify({ email: email })
                });
                const data = await response.json();
                if (response.ok) {
                    setTests(data.tests || []);
                    setMessage('');
                } else {
                    setMessage(`Error: ${data.message || 'Unable to load tests.'}`);
                }
            } catch (err) {
                setMessage(`Error: ${err.message}`);
            }
        };

        fetchTests();
    }, [user, navigate]);

    const handleLogout = () => {
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('email');
        console.log("Inside handleLogout - type of setUser:", typeof setUser);
        console.log("Inside handleLogout - value of setUser:", setUser);
        setUser(null);
     //   navigate('/');
        // Delay navigation slightly, or use a separate effect
        // OPTION A: Small delay (simplest test)
        setTimeout(() => {
            navigate('/');
        }, 0); // Execute navigate in the next event loop tick
    };
    console.log("Dashboard component render phase - AFTER functions defined"); // Add this
    console.log('[Dashboard] setUser is:', typeof setUser);
   //< button onClick = {() => alert("Start test logic coming soon!")}> Start New Test</button >
    return (
        <div>
            <h2>Welcome, {user?.email || localStorage.getItem('email')}</h2>
   
            <button onClick={() => navigate('/test-content')}>Start New Test</button>
            <h3>Past Tests</h3>
            {tests.length > 0 ? (
            <ul>
                {tests.map((test, idx) => (
                    <li key={idx}>
                        {test.timestamp} - Score: {test.score}
                    </li>
                ))}
            </ul>
            ) : (
                <p>No test results found.</p>
            )}
         
            <button onClick={handleLogout}>Logout</button>
            <p>{message}</p>
        </div>
    );
}

export default Dashboard;
